import { fansRising } from "@/mocks/hotlist";

export default function FansBoard() {
  const [top, ...others] = fansRising;

  return (
    <section id="fans" className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <div className="w-full max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
            <div>
              <span className="inline-flex items-center gap-2 text-xs md:text-sm text-secondary-400 font-medium">
                <span className="w-6 h-px bg-secondary-500" />
                围观涨粉榜
              </span>
              <h2 className="mt-3 font-heading text-3xl md:text-5xl font-bold text-foreground-950">
                谁在悄悄起量
              </h2>
              <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600 leading-relaxed">
                统计口径为账号单日净增关注，用来观察哪些方向的内容正在被更多人喜欢。所有账号统一使用栏目代称。
              </p>
            </div>
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-500/10 text-xs md:text-sm text-secondary-300 whitespace-nowrap">
              <i className="ri-line-chart-line" />
              单日净增关注排序
            </span>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
            <article className="lg:col-span-1 rounded-lg border border-secondary-500/40 bg-secondary-500/10 p-6 flex flex-col">
              <div className="flex items-center justify-between">
                <span className="px-2.5 py-1 rounded-md bg-secondary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                  本日榜首
                </span>
                <i className="ri-arrow-up-double-line text-secondary-400 text-xl" />
              </div>
              <h3 className="mt-6 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                {top.name}
              </h3>
              <p className="mt-2 text-sm text-foreground-600">{top.field}</p>
              <p className="mt-6 font-heading text-4xl md:text-5xl font-bold text-secondary-400 tabular-nums">
                {top.gained}
              </p>
              <p className="mt-4 text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">
                {top.note}
              </p>
            </article>

            <div className="lg:col-span-2 rounded-lg border border-background-200/70 bg-background-100 overflow-hidden">
              <div className="px-4 md:px-6 py-4 border-b border-background-200/70 flex items-center justify-between">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                  涨粉榜 2 - 6 名
                </h3>
                <span className="text-xs text-foreground-500">每日 20:00 结算</span>
              </div>
              <ul>
                {others.map((item) => (
                  <li
                    key={item.rank}
                    className="px-4 md:px-6 py-4 border-b border-background-200/50 last:border-b-0 flex items-center gap-4 hover:bg-background-200/40 transition-colors"
                  >
                    <span className="w-8 shrink-0 font-heading text-lg font-bold text-foreground-500 tabular-nums">
                      {item.rank}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="font-medium text-sm md:text-base text-foreground-950 truncate">
                        {item.name}
                      </p>
                      <p className="mt-1 text-xs text-foreground-600 truncate hidden sm:block">
                        {item.note}
                      </p>
                    </div>
                    <span className="px-2 py-0.5 rounded-md bg-background-200/70 text-xs text-foreground-600 whitespace-nowrap hidden md:inline">
                      {item.field}
                    </span>
                    <span className="shrink-0 font-medium text-sm md:text-base text-secondary-300 tabular-nums w-20 text-right">
                      {item.gained}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}